export const CERTIFICATE_LIST_REQUEST = 'CERTIFICATE_LIST_REQUEST'
export const CERTIFICATE_LIST_SUCCESS = 'CERTIFICATE_LIST_SUCCESS'
export const CERTIFICATE_LIST_FAIL = 'CERTIFICATE_LIST_FAIL'

